<template>
  <div id="chart-line-item-item-box">
    <chart-title
      leftTitle="PDM板材颜色销售榜 left_2"
      :rightTitle="`${formatTime(date, 'yyyy年MM月')}`"
      :tooltipText="'预优化开单实时板材数量'"
    >
      <el-button
        type="primary"
        slot="detail"
        size="mini"
        style="margin-left: 10px"
        @click="handleDetail"
        >详 情</el-button
      >
    </chart-title>
    <date-change-card
      height="calc(100% - 30px)"
      @leftClick="leftClick"
      @rightClick="rightClick"
    >
      <div id="left_2" slot="main" />
    </date-change-card>
  </div>
</template>

<script>
import resize from "@/utils/resize";
import ChartTitle from "../../../components/chartTitle";
import DateChangeCard from "../../../components/dateChangeCard";
import { charts } from "@/api/cockpit/sp";
import {
  formatTime,
  getNextMonth,
  getLastDate,
  getFirstDate,
  arrDataFormat,
} from "@/utils/index";
export default {
  mixins: [resize],
  name: "left_2",
  components: { ChartTitle, DateChangeCard },
  data() {
    return {
      chart: null,
      date: new Date(),
      chartData: "",
    };
  },
  props: {},
  created() {},
  mounted() {
    this.getData();
  },

  beforeDestroy() {
    if (!this.chart) {
      return;
    }
    this.chart.dispose();
    this.chart = null;
  },
  methods: {
    formatTime,
    //获取数据
    getData() {
      charts({
        add_time: formatTime(this.date, "yyyy-MM-01"),
      }).then((resp) => {
        this.chartData = resp.data.list;
        this.initChart();
      });
    },
    initChart() {
      this.chart = this.$echarts.init(document.getElementById("left_2"));
      this.setOptions();
    },
    setOptions() {
      const color = ["59,157,255", "34,228,255", "59,255,208", "4,227,138"];
      let seriesData = this.chartData.map((m) => {
        return {
          value: m.s_quantity,
        };
      });

      seriesData = seriesData.map((m, i) => {
        return {
          value: m.value,
          itemStyle: {
            color: new this.$echarts.graphic.LinearGradient(1, 0, 0, 0, [
              {
                offset: 0,
                color: `rgba(${color[i % 4]},1)`,
              },
              {
                offset: 1,
                color: `rgba(${color[i % 4]},0.1)`,
              },
            ]),
          },
        };
      });
      this.chart.setOption({
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "shadow",
          },
        },
        legend: {
          show: false,
        },
        grid: {
          top: "10%",
          bottom:"5%",
          right:"16%",
          left:"6%",
          center:"center",
          containLabel: true,
        },
        xAxis: {
          type: "value",
          boundaryGap: [0, 0.01],
          axisLabel: {
            color: "#606266",
            fontSize: "10",
          },
          axisLine: {
            lineStyle: {
              color: "#606266",
            },
          },
          splitLine: {
            lineStyle: {
              color: "#606266",
              type: "dashed", //设置网格线类型 dotted：虚线 solid:实线
            },
          },
        },
        yAxis: {
          type: "category",
          inverse: true,
          axisLine: {
            lineStyle: {
              color: "#606266",
            },
          },
          axisLabel: {
            color: "#909399",
            fontSize: "10",
          },
          data: this.chartData.map((m) => m.color),
        },
        series: [
          {
            name: "销售额（张）",
            type: "bar",
            barWidth: 5,
            itemStyle: {
              borderRadius: 5,
            },
            data: seriesData,
          },
        ],
      });
    },
    //前一月
    leftClick() {
      this.date = getNextMonth(formatTime(this.date, "yyyy-MM-01"), -1);
      this.getData();
    },
    //后一月
    rightClick() {
      this.date = getNextMonth(formatTime(this.date, "yyyy-MM-01"), +1);
      this.getData();
    },
    handleDetail() {
      window.open(
        `${process.env.VUE_APP_SP_URL}/#/login?nameJSC=订单板材用量统计表&username=${process.env.VUE_APP_NAME_PDM}&password=${process.env.VUE_APP_PASS}`,
        "_blank"
      );
    },
  },
};
</script>

<style lang="scss" scoped>
#chart-line-item-item-box {
  // background: rgba(125, 155, 243, 0.2);
  height: 63vh;
  #left_2 {
    height: 100%;
    // width: 100%;
    // display: flex;
    // justify-content: center;
    // padding-top: 10px;
  }
}
</style>
